const initialState = {
  body: '',
  pageId: null,
  posX: null,
  posY: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'POPPIN_FORM_BODY_SET':
      return Object.assign({}, state, { body: action.body });
    case 'POPPIN_FORM_CLOSE':
      return initialState;
    case 'POPPIN_FORM_OPEN':
      return {
        body: action.body, pageId: action.pageId, posX: action.posX, posY: action.posY
      };
    default:
      return state;
  }
}
